import React, { lazy } from "react";

const LazyMonthlyInsights = lazy(() => import("./MonthlyInsights"));

const MonthlyInsights = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyMonthlyInsights {...props} />;

export default MonthlyInsights;
